import AxiosConfig from "@/config/axiosConfig/AxiosConfig";
import config from "@/config";

const UserService = {
    register: async (params) => {
        try {
            const resp = await AxiosConfig.post(config.api.user + '/register', { params });
            return resp.data;
        } catch (err) {
            console.error(err)
            return Promise.reject(err)
        }
    },

}
export default UserService;